import { getFileIcon } from '@/modules/tasks/utils/getFileIcon';
import { FileMinifiedFragment } from '@/modules/tasks/views/TasksDashboard/graphql/fragments/generated/fileMinified';

export const getFilesFilterOption = (file: FileMinifiedFragment) => {
  return {
    value: file.id,
    label: file.name,
    Icon: () => getFileIcon(file, 20, ''),
  };
};
